import { makeStylesheetLink } from "@self/stylesheet";

export class ViewMoreProducts extends HTMLElement {
    shadow: ShadowRoot;
    button: HTMLButtonElement;

    constructor() {
        super();

        this.shadow = this.attachShadow({ mode: "open" });

		this.button = <button type="button" id="view-more-products" className="gct-btn-lg gct-btn-tertiary">View More</button> as HTMLButtonElement;

        this.button.addEventListener("click", onloadMoreProducts.bind(this));

        this.shadow.append(
			this.button,
			makeStylesheetLink()
		);
    }

	connectedCallback() {
		this.button.addEventListener("change", onloadMoreProducts.bind(this));
	}

	disconnectedCallback() {
		this.button.removeEventListener("change", onloadMoreProducts.bind(this));
	}


}

async function onloadMoreProducts(this: ViewMoreProducts) {
	const currentPage = parseInt(this.dataset.page?? "1");
	const maxProductsPerPage = parseInt(this.dataset.productsPerPage?? "20");

	try {

		this.button.disabled = true;

		let urlString : string;


		//Search params
		const searchParamIndex = this.dataset.url!.indexOf('?s=');

		if (searchParamIndex !== -1) {
			const baseUrl = this.dataset.url!.substring(0, searchParamIndex);
			const searchParams = this.dataset.url!.substring(searchParamIndex);
			urlString = `${baseUrl}page/${currentPage+1}${searchParams}`;
		} else {
			urlString =`${this.dataset.url!}page/${currentPage+1}`
		}

		//Sort by
		const currentUrl = new URL(urlString);

		const sortDropdown = document.querySelector("gct-sort-dropdown");

		const dropdownValue = (sortDropdown?.shadowRoot?.getElementById("sort-dropdown") as HTMLSelectElement).value;

		if (dropdownValue !== "default") currentUrl.searchParams.set("orderby", dropdownValue);

		console.log(currentUrl.toString());

		const response = await fetch(currentUrl.toString());

		const html = await response.text();

		const doc = new DOMParser().parseFromString(html, 'text/html');

		const newProducts = doc.getElementsByName("product-content-tile");

		const newProductsArray = Array.from(newProducts);

		const oldContent = document.getElementById("product-loop-archive");

		newProductsArray.forEach(product => {
			oldContent!.appendChild(product);
		});

		this.setAttribute("data-page", `${currentPage+1}`);

		if (newProductsArray.length < maxProductsPerPage) {
			this.button.style.display = 'none';
		}
	} catch (error) {
		console.error('Error loading more products:', error);
	} finally {
		this.button.disabled = false;
	}
}
